import { runtimeConfig } from "@src/runtime-config";
import { RuntimeUtils } from "@stellar/utils";
/** Transmit the updated setting to the parent window */
export function transmitSettingsToParent({
  settingIdentifier,
  settingValue
}) {
  const message = {
    action: "updateSetting",
    data: {
      settingIdentifier,
      settingValue
    }
  };

  // Need to allow specific origins in for security reasons
  const targetOrigins = RuntimeUtils.isProductionEnvironment(runtimeConfig.appEnv) ? runtimeConfig.urls.sphereViewerUrl : "*";
  window.parent.postMessage(message, targetOrigins);
}